/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { storageFactory } from "../../../../../utils/storageFactory";
import { useDropzone } from "react-dropzone";

import * as UtilsHelper from "../../../../../utils/utilsHelper";
import * as zoneActions from "../../../../store/actions/zoneActions";
import * as fileUploadActions from "../../../../store/actions/fileUploadActions";
import * as DocumentService from "../../../../secure/services/documentService";
import * as documentActions from "../../../../store/actions/documentActions";
import * as templateActions from "../../../../store/actions/templateActions";
import * as actionsLoader from "../../../../store/actions/loaderActions";
import { StorageHelper } from "../../../../../utils/storageHelper";

import _ from "underscore";
import DocumentViewModal from "./DocumentViewModal";
import APP_CONST from "../../../shared/constants";
import ProgressBar from "../../shared/widgets/ProgressBar";
import Loader from "../../shared/Loader/Loader";
import DeleteDocumentPopUp from "../../shared/DeleteDocumentPopUp/DeleteDocumentPopUp";
import DropdownFilters from "../../shared/DropdownFIlters/DropdownFilters";
import PlaceholderComponent from "../../../containers/ArchiveDashboard/PlaceholderComponent";

const ZonesSections = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    fullDateTimePattern,
    dateLocale,
    settings,
    isEtmfLocked,
    mileStoneListWithGroup,
    lockStatus,
  } = useSelector((store) => store.template);

  const {
    documentDataList,
    userList,
    metricsData,
    viewPerPageCount,
    countrySiteList,
    artifactLoading,
    selectedMilestoneID,
    selectedSiteID,
    selectedCountryID,
    sectionLoading,
    fileDetails,
    uploadProgress,
    sharingDetails,
    cancelDocId,
    failedFileDetails,
    isOverViewLoading,
  } = useSelector((store) => store.zone);

  const { downLoader, scanSuccessInfo } = useSelector((store) => store.file);
  const { zoneData, documentsLoading, deletingDocuments, accordanceData } =
    useSelector((store) => store.document);
  let zoneSectionInfo;
  const fileRef = useRef();
  const [fileRefVisible, setFileRefVisible] = useState(false);
  const [docDetails, setDocDetails] = useState();
  const [selectedDocId, setSelectedDocId] = useState();
  const [selectedDocArtifactId, setSelectedDocArtifactId] = useState();
  const [artifactMilestoneDetails, setArtifactMilestoneDetails] = useState({});
  const [viewDocumentObj, setViewDocumentObj] = useState(false);

  const [zoneId, setZoneid] = useState("");
  const [sectionId, setSectionId] = useState();
  const [selectedSection, setSelectedSection] = useState();
  const [artifactId, setArtifactId] = useState("");
  const [activeZoneId, setActiveZoneId] = useState("");
  const [downloadingDocId, setDownloadingDocId] = useState("");
  const [showDocDeletePopup, setShowDocDeletePopup] = useState(false);
  const [docDeleteData, setDocDeleteData] = useState({});
  const [sectionOrigid, setSectionOrigid] = useState("");
  const [getorigiartifactid, setorigiartifactid] = useState("");
  const [docList, setDocList] = useState({});
  const [docFilterUsed, setDocFilterUsed] = useState(false);
  const [dragContainer, setDragContainer] = useState(false);
  const [selectedArtifactDetails, setSelectedArtifactDetails] = useState({});
  const [callCount, setCallCount] = useState(0);
  const [tmpfileGuid, setTmpFileGuid] = useState(null);
  const [tmpSingleFileDetail, setTmpSingleFileDetail] = useState(null);
  const [isDocNewVersionCreated, setIsDocNewVersionCreated] = useState(false);
  const zoneIndex = zoneData?.find((item) => item.id === zoneId);
  const sectionIndex = zoneIndex?.sections?.find(
    (item) => item.id === sectionId
  );
  useEffect(() => {
    if (!fileRefVisible) {
      return;
    }
  }, [fileRefVisible]);
  const filterData = StorageHelper?.getFilterInfo();
  const latestSiteFilter =
    !_.isEmpty(filterData) && filterData.selectedSiteID !== undefined
      ? filterData.selectedSiteID
      : selectedSiteID;
  const latestCountryFilter =
    !_.isEmpty(filterData) && filterData.selectedCountryID !== undefined
      ? filterData.selectedCountryID
      : selectedCountryID;
  const latestMileFilter =
    !_.isEmpty(filterData) && filterData.selectedMilestoneID !== undefined
      ? filterData.selectedMilestoneID
      : selectedMilestoneID;
  const artifactsData =
    sectionIndex?.artifacts.map((artifact) => {
      return {
        Accordance: !_.isEmpty(
          accordanceData.filter((acc) => acc.artifactorigid === artifact.origid)
        )
          ? accordanceData.filter(
              (acc) => acc.artifactorigid === artifact.origid
            )[0].Accordance || false
          : false,
        artifacts: artifact.name,
        artifactorigid: artifact.origid,
        id: artifact.id,
        datingconvention: artifact.datingconvention,
        isdeleted: artifact.isdeleted,
        countrylevelmilestone: artifact.countrylevelmilestone,
        sitelevelmilestone: artifact.sitelevelmilestone,
        triallevelmilestone: artifact.triallevelmilestone,
        applicableincountry: artifact.applicableincountry,
        applicableintrial: artifact.applicableintrial,
        applicableatsite: artifact.applicableatsite,
        artifactuseraccess: artifact.artifactuseraccess,
        rolePermission: artifact.rolePermission,
        milestonesId: artifact.milestonesId,
        milestonesgroup: artifact.milestonesgroup,
      };
    }) ?? [];

  const artifactUserAccess = artifactsData?.filter(
    (artdata) => artdata.artifactorigid === artifactId
  )[0]?.artifactuseraccess;
  const rolePermission = artifactsData?.filter(
    (artdata) => artdata.artifactorigid === artifactId
  )[0]?.rolePermission;

  const recordStatusTooltip = (status) => {
    switch(status) {
      case APP_CONST.TEXT_REQUIURED:
        return t("TMF.TOOLTIP_RECORD_REQUIRED")
      case APP_CONST.TEXT_FLAGGEDBYQC:
        return t("TMF.TOOLTIP_RECORD_FLAGGED")
      case APP_CONST.TEXT_AWAITINGREVIEW:
        return t("TMF.TOOLTIP_RECORD_AWAITING")
      case APP_CONST.TEXT_FINALIZED:
        return t("TMF.TOOLTIP_RECORD_FINALIZED")
      case  APP_CONST.TEXT_UNPUBLISHED:
        return t("TMF.TOOLTIP_RECORD_UNPUBLISHED")
      default:
        break;  
    }
  }

  const zoneSectionHeader = [
    {
      className: "close-document",
      icon: <viedoc-icon name="required" title={recordStatusTooltip(APP_CONST.TEXT_REQUIURED)}/>,
    },
    {
      className: "flagged",
      icon: <viedoc-icon name="flag" class="flag-icon" title={recordStatusTooltip(APP_CONST.TEXT_FLAGGEDBYQC)}/>,
    },
    {
      className: "awaiting",
      icon: <viedoc-icon name="load" class="awaiting-icon" title={recordStatusTooltip(APP_CONST.TEXT_AWAITINGREVIEW)}/>,
    },
    {
      className: "checked",
      icon: <viedoc-icon name="check" title={recordStatusTooltip(APP_CONST.TEXT_FINALIZED)}/>,
    },
    {
      className: "blocked",
      icon: <viedoc-icon name="block" title={recordStatusTooltip(APP_CONST.TEXT_UNPUBLISHED)}/>,
    },
  ];

  useEffect(() => {
    if (callCount === 0) {
      setCallCount(callCount + 1);
      dispatch(documentActions.fetchAndLoadDocMaster());
      dispatch(zoneActions.fetchMetricsData());
      dispatch(templateActions.getDatingConventionList());
      dispatch(documentActions.getAdminSharingSettings());
      //country, site api for filter dropdown visibility on reload
      dispatch(templateActions.getCountry());
      dispatch(templateActions.getSite());
      
      // dispatch(templateActions.getTimeFormat());
      // dispatch(templateActions.getStudyInformation());
      // dispatch(templateActions.getMilestoneDropDownData());
      // dispatch(templateActions.getMilestoneGroup());
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    return () => dispatch({ type: "RESET_ACCORDANCE_DATA" });
  }, []);

  useEffect(() => {
    document.addEventListener("dialog-hide", (e) => {
      setViewDocumentObj(false);
      setShowDocDeletePopup(false);
    });
  }, []);

  useEffect(() => {
    if (selectedDocArtifactId) {
      const docDets = documentDataList[selectedDocArtifactId].find(
        (doc) => doc.docid === selectedDocId
      );
      setDocDetails(docDets);
    }
    let docs = documentDataList;
    Object.keys(docs).map((key) => {
      docs[key] = docs[key]?.map((doc) => {
        const reqObject = {
          artifactuseraccess: artifactUserAccess,
          rolePermission: rolePermission,
          documenttmflevel: doc.documenttmflevel,
          sitesid: doc.sitesid,
          countriesid: doc.countriesid,
          countrySiteList,
        };
        const permissionObject = UtilsHelper.permissionObject(reqObject);
        doc = {
          ...doc,
          ...permissionObject,
        };
        return doc;
      });
    });

    function errorDocsMerge(smaller, bigger) {
      for (let key in bigger) {
        if (key in smaller) {
          bigger[key] = [...smaller[key], ...bigger[key]];
        }
        let noDupes = UtilsHelper.removeDuplicates(bigger[key], "documentguid");
        bigger[key] = noDupes;
      }
      return bigger;
    }
    if (!_.isEmpty(JSON.parse(StorageHelper.getErrorDocument()))) {
      let errorDocuments = JSON.parse(StorageHelper.getErrorDocument());
      let groupedErrorDocs = _.groupBy(errorDocuments, "origiartifactid");
      errorDocsMerge(groupedErrorDocs, docs);
    }
    !docFilterUsed && setDocList(docs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentDataList]);

  const onDrop = (acceptedFiles, fileRejection, event) => {
    const dropArtifactId = event?.target?.closest('[data-custom-artifactId]')?.getAttribute('data-custom-artifactId');
    documentUploadHandler(acceptedFiles, artifactId, dropArtifactId);
  };
  const { getRootProps, getInputProps } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop: onDrop,
  });

  const zeroSectionHandler = (sectionData) => {
    if (!sectionData) {
      return "";
    }
    return "0";
  };

  const zeroZoneHandler = (zoneData) => {
    if (!zoneData) {
      return "";
    }
    return "0";
  };

  const zeroArtifactHandler = (info, accordance, value) => {
    if (!info) {
      return accordance ? "0" : null;
    } else {
      return value;
    }
  };

  useEffect(() => {
    const duplicatesRemoved = UtilsHelper.removeDuplicates(
      documentDataList[artifactId],
      "documentguid"
    );

    updatedArray(duplicatesRemoved);
  }, [artifactId]);

  useEffect(() => {
    if (!_.isEmpty(fileDetails)) {
      let docContent = fileDetails.documentcontents
        ? JSON.parse(fileDetails.documentcontents)
        : null;
      if (!_.isEmpty(docContent)) {
        const documentObj = {
          ...docContent.documentDetails,
          documentid: fileDetails.id,
          uploadingProgress: UtilsHelper.randomNumber([24, 27, 33, 37]),
        };
        if (!cancelDocId?.includes(fileDetails.id)) {
          updateArtifactList(documentObj, "update");
        }
      }
    }
  }, [fileDetails]);

  useEffect(() => {
    if (!_.isEmpty(failedFileDetails)) {
      let docContent = failedFileDetails.documentContents
        ? JSON.parse(failedFileDetails.documentContents)
        : null;
      if (!_.isEmpty(docContent)) {
        let docDetail = {
          ...docContent.documentDetails,
          status: "Error",
          comments:
            failedFileDetails.errorMessage ||
            `${t("TMF.TOAST_INVALIDSCANFILE")}`,
        };
        updateArtifactList(docDetail, "update");
      }
    }
  }, [failedFileDetails]);

  useEffect(() => {
    if (!_.isEmpty(uploadProgress)) {
      const documentObj = {
        ...uploadProgress.docObject,
        origiartifactid: uploadProgress.artifactId,
        documentid: uploadProgress.tmfdocumentid,
      };
      if (documentObj.uploadingProgress > 0) {
        if (!cancelDocId?.includes(uploadProgress.tmfdocumentid)) {
          updateArtifactList(documentObj, "update");
        }
      }
      // else updateArtifactList(documentObj, "delete");
    }
  }, [uploadProgress]);

  useEffect(() => {
    if (!_.isEmpty(scanSuccessInfo)) {
      const documentObj = {
        ...scanSuccessInfo.docObject,
        origiartifactid: scanSuccessInfo.artifactId,
        documentid: scanSuccessInfo.tmfdocumentid,
        status: scanSuccessInfo.documentstage,
      };
      updateArtifactList(documentObj, "update");
      const mergeArtifactDocData = [
        ...documentDataList[scanSuccessInfo.artifactId],
        documentObj,
      ];
      const documentList = UtilsHelper.removeDuplicates(
        mergeArtifactDocData,
        "documentguid"
      );
      const sectionPayload = {
        adminartifactsharingsettings: sharingDetails,
        documentDetails: documentList,
      };
      dispatch(
        zoneActions.getDocumentsBySectionSuccess(
          sectionPayload,
          scanSuccessInfo.artifactId
        )
      );
    }
  }, [scanSuccessInfo]);

  const updatedArray = (data) => {
    if (!_.isEmpty(JSON.parse(StorageHelper.getErrorDocument()))) {
      let errorDocuments = JSON.parse(StorageHelper.getErrorDocument());
      if (!_.isEmpty(data)) {
        let errorDoc = errorDocuments.filter(
          (errDoc) => errDoc.origiartifactid === data[0].origiartifactid
        );
        if (!_.isEmpty(errorDoc)) {
          errorDoc.map((er) => {
            data.push(er);
          });
        }
      }
    }

    const noDuplicateDocumentDataList = UtilsHelper.removeDuplicates(
      data,
      "documentguid"
    );

    let updatedRoleState = noDuplicateDocumentDataList?.map((obj) => {
      const { documenttmflevel, countriesid, sitesid } = obj;
      const reqObject = {
        artifactuseraccess: artifactUserAccess,
        rolePermission: rolePermission,
        documenttmflevel: documenttmflevel,
        sitesid: sitesid,
        countriesid: countriesid,
        countrySiteList,
      };
      const permissionObject = UtilsHelper.permissionObject(reqObject);
      let displayDateTime = obj.lastmodifiedon
        ? UtilsHelper.momentLocalConversion(obj.lastmodifiedon, true)
        : UtilsHelper.momentLocalConversion(obj.createdon, true);
      displayDateTime =
        displayDateTime || UtilsHelper.momentLocalConversion(new Date(), true);
      const displayOrder = UtilsHelper.constructDisplayOrder(obj.status);
      return { ...obj, ...permissionObject, displayDateTime, displayOrder };
    });
    updatedRoleState = updatedRoleState?.sort((a, b) =>
      b.displayDateTime.localeCompare(a.displayDateTime)
    );

    const groupByDisplayOrder = _.groupBy(updatedRoleState, "displayOrder");
    let sortedRoleState = [];
    Object.keys(groupByDisplayOrder).map((key) => {
      sortedRoleState = [...sortedRoleState, ...groupByDisplayOrder[key]];
    });

    sortedRoleState = UtilsHelper.removeDuplicates(
      sortedRoleState,
      "documentguid"
    );

    setDocList({
      ...documentDataList,
      [artifactId]: sortedRoleState,
    });

    return sortedRoleState;
  };

  const getArtifactsHandler = (item, status, id) => {
    if (!documentDataList?.hasOwnProperty(item.artifactorigid)) {
      const initializeDocumentData = {
        [item.artifactorigid]: [],
      };
      dispatch({
        type: "RESET_DOCUMENT_DATA_LIST",
        payload: initializeDocumentData,
      });
    }
    setArtifactId(item.artifactorigid);
    const zoneIndex = zoneData.find((item) => item.id === zoneId);
    const sectionIndex = zoneIndex?.sections?.find(
      (item) => item.id === sectionId
    );
    const AccordanceArtifact = sectionIndex?.artifacts.find(
      (arti) => arti.origid === item.artifactorigid
    );

    AccordanceArtifact.Accordance = status ? status : !item.Accordance;
    const accordanceDataList = artifactsData.map((artifact) => {
      if (artifact.artifactorigid === AccordanceArtifact.origid) {
        return {
          Accordance: AccordanceArtifact.Accordance,
          artifactorigid: artifact.artifactorigid,
        };
      }
      return {
        Accordance: artifact.Accordance,
        artifactorigid: artifact.artifactorigid,
      };
    });
    dispatch({ type: "SET_ACCORDANCE_DATA", payload: accordanceDataList });
    if (artifactId === item.artifactorigid && !status) {
      // AccordanceZone.Accordance = false;
      setArtifactId("");
      return;
    }
    setArtifactMilestoneDetails({
      ...artifactMilestoneDetails,
      [item.artifactorigid]: {
        countrylevelmilestone: item.countrylevelmilestone,
        sitelevelmilestone: item.sitelevelmilestone,
        triallevelmilestone: item.triallevelmilestone,
      },
    });
    !id && dispatch(zoneActions.getDocumentsByArtifact(item.artifactorigid));
  };

  const isUUID = (uuid) => {
    let s = "" + uuid;
    s = s.match(
      "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
    );
    if (s === null) {
      return false;
    }
    return true;
  };

  const checkSelectedMilestone = (input) => {
    let selectedMIlestoneIDs = [];
    isUUID(input)
      ? selectedMIlestoneIDs.push(input)
      : mileStoneListWithGroup.filter(
          (list) => list.group === input && selectedMIlestoneIDs.push(list.id)
        );
    return selectedMIlestoneIDs;
  };

  const loadSelectedMilestoneData = (obj, milestoneArr) => {
    let getArtifactObj = sectionIndex.artifacts?.find(
      (arti) => arti.name === obj.artifact
    );
    let checkObj =
      obj.documenttmflevel === "Site"
        ? "sitelevelmilestone"
        : obj.documenttmflevel === "Country"
        ? "countrylevelmilestone"
        : obj.documenttmflevel === "Trial"
        ? "triallevelmilestone"
        : "";
    let returnValue = false;
    if (checkObj !== "" && !_.isEmpty(getArtifactObj)) {
      if (milestoneArr?.includes(getArtifactObj[checkObj])) {
        returnValue = true;
      }
    }
    return returnValue;
  };

  const renderHeaderComponent = () => {
    return (
      <div className="zone-section-content pl-30 pr-30">
        <h3>{t("ADMIN.ADMINTAB_STRUCTURE")}</h3>
        <DropdownFilters currentArtifactId={artifactId} />
      </div>
    );
  };

  const renderZoneSectionHeader = () => {
    return (
      <div className="d-flex align-center pad-20 section-bg bb-1 br-1">
        <div className="w-60 f16 d-flex justfy-content-flex-start">
          {t("TMF.CONTAINER_ZONESECTION")}
        </div>
        <div className="w-40 d-flex zone-section-icon">
          {zoneSectionHeader.map((fieldValue) => (
            <p key={fieldValue.className} className={fieldValue.className}>
              {fieldValue.icon}
            </p>
          ))}
        </div>
      </div>
    );
  };

  function handleClickSections(item, origid) {
    if (sectionId === item) {
      setSectionId("");
      return;
    }
    dispatch({ type: "RESET_ACCORDANCE_DATA" });
    dispatch(zoneActions.getDocumentsBySection(origid));
    dispatch(zoneActions.fetchMetricsData());
    setSectionId(item);
    setSelectedSection(origid);
  }

  const renderSectionIcons = () => {
    zoneSectionInfo = metricsData?.zoneinfo?.filter(
      (zoneData) => zoneData.zoneid === activeZoneId
    );
  };

  const checkDocRequiredLevel = (docRequiredLevel) => {
    return !_.isEmpty(docRequiredLevel)
  }

  const ZoneSectionArtifactActive = (isActive, tooltipText) => {
    return isActive ? tooltipText : ""
  }

  const renderSectionOfZoneTable = (item) => {
    return (
      <>
        <div
          className={`d-flex align-center zone-list bb-1 cursor-pointer ${
            selectedOptions(sectionId, item.id)
              ? "zone-list-active"
              : "zone-list-inactive"
          }`}
          onClick={() => handleClickSections(item.id, item.origid)}
        >
          <div className="w-60 d-flex align-center zone-artifact-row">
            <div className="zone-section zone-artifact" title={item.origid + " " + item.name}>
              <viedoc-icon
                name={
                  selectedOptions(sectionId, item.id) ? "sections" : "folder"
                }
                class={
                  selectedOptions(sectionId, item.id)
                    ? "zones-grey"
                    : "zones-dark"
                }
              />
            </div>
            <p
              className={item.isdeleted ? "deleted-zdata" : ""}
              title={item.origid + " " + item.name}
            >
              {settings.showstructurenumber
                ? `${item.origid} ${item.name}`
                : item.name}
            </p>
          </div>
          <div className="w-40 d-flex zone-section-icon">
            {renderSectionIcons()}
            {!_.isEmpty(zoneSectionInfo) &&
              !_.isEmpty(zoneSectionInfo[0]?.sectioninfo) &&
              zoneSectionInfo[0]?.sectioninfo?.map((sectionData) => {
                if (sectionData.sectionid === item.origid) {
                  return (
                    <Fragment key={sectionData.sectionid}>
                      <p
                        className={
                          selectedOptions(sectionId, item.id) && checkDocRequiredLevel(sectionData?.docrequiredlevels)
                            ? "close-document"
                            : "close-document-inactive"
                        }
                        title={ZoneSectionArtifactActive(selectedOptions(sectionId, item.id) && checkDocRequiredLevel(sectionData?.docrequiredlevels), recordStatusTooltip(APP_CONST.TEXT_REQUIURED))}
                      >
                        {isOverViewLoading &&
                        sectionData.sectionid === selectedSection ? (
                          <viedoc-spinner
                            class={`metrics-spinner`}
                          />
                        ) : (
                          checkDocRequiredLevel(sectionData?.docrequiredlevels) ? <viedoc-icon name="required"></viedoc-icon> : <></>
                        )}
                      </p>
                      <p className={sectionId === item.id ? "flagged" : ""}
                        title={ZoneSectionArtifactActive(selectedOptions(sectionId, item.id), recordStatusTooltip(APP_CONST.TEXT_FLAGGEDBYQC))}
                      >
                        {!isOverViewLoading ? (
                          <span
                            className={
                              sectionData.flaggedbyqc >= 9 ? "pr-4" : "pr-1"
                            }
                          >
                            {sectionData.flaggedbyqc >= 9
                              ? "+9"
                              : sectionData.flaggedbyqc !== 0
                              ? sectionData.flaggedbyqc
                              : zeroSectionHandler(sectionId === item.id)}
                          </span>
                        ) : (
                          ""
                        )}
                      </p>
                      <p className={sectionId === item.id ? "awaiting" : ""} 
                        title={ZoneSectionArtifactActive(selectedOptions(sectionId, item.id), recordStatusTooltip(APP_CONST.TEXT_AWAITINGREVIEW))}
                      >
                        {!isOverViewLoading ? (
                          <span
                            className={
                              sectionData.awaitingreview >= 9 ? "pr-4" : "pr-1"
                            }
                          >
                            {sectionData.awaitingreview >= 9
                              ? "+9"
                              : sectionData.awaitingreview !== 0
                              ? sectionData.awaitingreview
                              : zeroSectionHandler(sectionId === item.id)}
                          </span>
                        ) : (
                          ""
                        )}
                      </p>
                      <p className={sectionId === item.id ? "checked" : ""}
                        title={ZoneSectionArtifactActive(selectedOptions(sectionId, item.id), recordStatusTooltip(APP_CONST.TEXT_FINALIZED))}
                      >
                        {!isOverViewLoading ? (
                          <span
                            className={
                              sectionData.finalized >= 9 ? "pr-4" : "pr-1"
                            }
                          >
                            {sectionData.finalized >= 9
                              ? "+9"
                              : sectionData.finalized !== 0
                              ? sectionData.finalized
                              : zeroSectionHandler(sectionId === item.id)}
                          </span>
                        ) : (
                          ""
                        )}
                      </p>
                      <p className={sectionId === item.id ? "blocked" : ""}
                        title={ZoneSectionArtifactActive(selectedOptions(sectionId, item.id), recordStatusTooltip(APP_CONST.TEXT_UNPUBLISHED))}
                      >
                        {!isOverViewLoading ? (
                          <span
                            className={
                              sectionData.unpublished >= 9 ? "pr-4" : "pr-1"
                            }
                          >
                            {sectionData.unpublished >= 9
                              ? "+9"
                              : sectionData.unpublished !== 0
                              ? sectionData.unpublished
                              : zeroSectionHandler(sectionId === item.id)}
                          </span>
                        ) : (
                          ""
                        )}
                      </p>
                    </Fragment>
                  );
                }
              })}
          </div>
        </div>
      </>
    );
  };
  const checkRolePermission = (item) => {
    let rolePermissionState =
      item.artifactorigid === "00.00.00" ? "WRITE" : item.rolePermission;
    return APP_CONST.ALLOW_TO_UPLOAD.includes(rolePermissionState);
  };
  function handleClick(item, origid) {
    if (zoneId === item) {
      setZoneid("");
      return;
    }
    setZoneid(item);
    setActiveZoneId(origid);
    setSectionId("");
  }

  const selectedOptions = (zoneId, id) => {
    return zoneId === id;
  };

  const renderZoneSectionTable = () => {
    return (
      !_.isEmpty(zoneData) && (
        <div>
          {zoneData?.map((item) => (
            <Fragment key={item.id}>
              <div
                className={`d-flex align-center zone-list bb-1 cursor-pointer ${
                  selectedOptions(zoneId, item.id)
                    ? "zone-list-active"
                    : "zone-list-inactive"
                }`}
                onClick={() => handleClick(item.id, item.origid)}
              >
                <div className="w-60 d-flex align-center">
                  <div className="zone-section" title={item.origid + " " + item.name}>
                    <viedoc-icon
                      name={
                        selectedOptions(zoneId, item.id) ? "zones" : "folder"
                      }
                      class={
                        selectedOptions(zoneId, item.id)
                          ? "zones-grey"
                          : "zones-dark"
                      }
                    />
                  </div>
                  <p
                    className={item.isdeleted ? "deleted-zdata" : ""}
                    title={item.origid + " " + item.name}
                  >
                    {settings.showstructurenumber
                      ? `${item.origid} ${item.name}`
                      : item.name}
                  </p>
                </div>
                {!_.isEmpty(metricsData) &&
                  !_.isEmpty(metricsData.zoneinfo) &&
                  metricsData?.zoneinfo?.map((zoneData) => {
                    if (item.origid === zoneData.zoneid) {
                      return (
                        <div
                          key={zoneData.id}
                          className="w-40 d-flex zone-section-icon"
                        >
                          <p
                            className={
                              selectedOptions(zoneId, item.id) && checkDocRequiredLevel(zoneData?.docrequiredlevels)
                                ? "close-document"
                                : "close-document-inactive"
                            }
                            title={ZoneSectionArtifactActive(selectedOptions(zoneId, item.id) && checkDocRequiredLevel(zoneData?.docrequiredlevels), recordStatusTooltip(APP_CONST.TEXT_REQUIURED))}
                          >
                           {checkDocRequiredLevel(zoneData?.docrequiredlevels) &&  <viedoc-icon name="required" />}
                          </p>
                          <p className={zoneId === item.id ? "flagged" : ""}  
                            title={ZoneSectionArtifactActive(selectedOptions(zoneId, item.id), recordStatusTooltip(APP_CONST.TEXT_FLAGGEDBYQC))}
                          >
                            <span
                              className={
                                zoneData.flaggedbyqc >= 9 ? "pr-4" : "pr-1"
                              }
                            >
                              {zoneData.flaggedbyqc >= 9
                                ? "+9"
                                : zoneData.flaggedbyqc !== 0
                                ? zoneData.flaggedbyqc
                                : zeroZoneHandler(zoneId === item.id)}
                            </span>
                          </p>
                          <p className={zoneId === item.id ? "awaiting" : ""}
                            title={ZoneSectionArtifactActive(selectedOptions(zoneId, item.id), recordStatusTooltip(APP_CONST.TEXT_AWAITINGREVIEW))}
                          >
                            <span
                              className={
                                zoneData.awaitingreview >= 9 ? "pr-4" : "pr-1"
                              }
                            >
                              {zoneData.awaitingreview >= 9
                                ? "+9"
                                : zoneData.awaitingreview !== 0
                                ? zoneData.awaitingreview
                                : zeroZoneHandler(zoneId === item.id)}
                            </span>
                          </p>
                          <p className={zoneId === item.id ? "checked" : ""}
                            title={ZoneSectionArtifactActive(selectedOptions(zoneId, item.id), recordStatusTooltip(APP_CONST.TEXT_FINALIZED))}
                          >
                            <span
                              className={
                                zoneData.finalized >= 9 ? "pr-4" : "pr-1"
                              }
                            >
                              {zoneData.finalized >= 9
                                ? "+9"
                                : zoneData.finalized !== 0
                                ? zoneData.finalized
                                : zeroZoneHandler(zoneId === item.id)}
                            </span>
                          </p>
                          <p className={zoneId === item.id ? "blocked" : ""}
                            title={ZoneSectionArtifactActive(selectedOptions(zoneId, item.id), recordStatusTooltip(APP_CONST.TEXT_UNPUBLISHED))}
                          >
                            <span
                              className={
                                zoneData.unpublished >= 9 ? "pr-4" : "pr-1"
                              }
                            >
                              {zoneData.unpublished >= 9
                                ? "+9"
                                : zoneData.unpublished !== 0
                                ? zoneData.unpublished
                                : zeroZoneHandler(zoneId === item.id)}
                            </span>
                          </p>
                        </div>
                      );
                    }
                  })}
              </div>
              {zoneId === item.id &&
                item?.sections?.map((item, index) => (
                  <Fragment key={index}>
                    {renderSectionOfZoneTable(item)}{" "}
                  </Fragment>
                ))}
            </Fragment>
          ))}
        </div>
      )
    );
  };

  const renderTrialSubsections = (item) => {
    return (
      <div className="zone-section">
        {!_.isEmpty(metricsData) &&
          !_.isEmpty(metricsData?.artifactinfo) &&
          metricsData?.artifactinfo.map((info) => {
            if (info.artifactid === item.artifactorigid) {
              return (
                <Fragment key={info.artifactid}>
                  {checkDocRequiredLevel(info?.docrequiredlevels) &&
                  <p
                    className={
                      item.Accordance
                        ? "close-section"
                        : "close-section-inactive"
                    }
                    title={ZoneSectionArtifactActive(item.Accordance && checkDocRequiredLevel(info?.docrequiredlevels), recordStatusTooltip(APP_CONST.TEXT_REQUIURED))}
                  >
                    {isOverViewLoading ? (
                      <viedoc-spinner class="metrics-spinner" />
                    ) : (
                      checkDocRequiredLevel(info?.docrequiredlevels) ? <viedoc-icon name="required"></viedoc-icon> : <></>
                    )}
                  </p>
                  }

                  <p
                    className={
                      item.Accordance
                        ? "flagged-section"
                        : "flagged-section-inactive"
                    }
                    title={ZoneSectionArtifactActive(item.Accordance, recordStatusTooltip(APP_CONST.TEXT_FLAGGEDBYQC))}
                  >
                    {info.flaggedbyqc !== 0 ? (
                      !isOverViewLoading ? (
                        <>
                          <viedoc-icon
                            name="flag"
                            className="flag-icon"
                          ></viedoc-icon>

                          <p>{info.flaggedbyqc}</p>
                        </>
                      ) : (
                        ""
                      )
                    ) : !isOverViewLoading && item.Accordance ? (
                      <>
                        <viedoc-icon
                          name="flag"
                          className="flag-icon"
                        ></viedoc-icon>

                        <p>
                          {zeroArtifactHandler(
                            info.artifactId === item.artifactorigid,
                            item.Accordance,
                            info.flaggedbyqc
                          )}
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                  </p>

                  <p
                    className={
                      item.Accordance
                        ? "awaiting-section"
                        : "awaiting-section-inactive"
                    }
                    title={ZoneSectionArtifactActive(item.Accordance, recordStatusTooltip(APP_CONST.TEXT_AWAITINGREVIEW))}
                  >
                    {info.awaitingreview !== 0 ? (
                      !isOverViewLoading ? (
                        <>
                          <viedoc-icon
                            name="load"
                            className="awaiting-icon"
                          ></viedoc-icon>
                          <p>{info.awaitingreview}</p>
                        </>
                      ) : (
                        ""
                      )
                    ) : !isOverViewLoading && item.Accordance ? (
                      <>
                        <viedoc-icon
                          name="load"
                          className="awaiting-icon"
                        ></viedoc-icon>

                        <p>
                          {zeroArtifactHandler(
                            info.artifactId === item.artifactorigid,
                            item.Accordance,
                            info.awaitingreview
                          )}
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                  </p>
                  <p
                    className={
                      item.Accordance
                        ? "success-section"
                        : "success-section-inactive"
                    }
                    title={ZoneSectionArtifactActive(item.Accordance, recordStatusTooltip(APP_CONST.TEXT_FINALIZED))}
                  >
                    {info.finalized !== 0 ? (
                      !isOverViewLoading ? (
                        <>
                          <viedoc-icon name="check"></viedoc-icon>
                          <p>{info.finalized}</p>
                        </>
                      ) : (
                        ""
                      )
                    ) : !isOverViewLoading && item.Accordance ? (
                      <>
                        <viedoc-icon name="check"></viedoc-icon>

                        <p>
                          {zeroArtifactHandler(
                            info.artifactId === item.artifactorigid,
                            item.Accordance,
                            info.finalized
                          )}
                        </p>
                      </>
                    ) : (
                      " "
                    )}
                  </p>

                  <p
                    className={
                      item.Accordance
                        ? "block-section"
                        : "block-section-inactive"
                    }
                    title={ZoneSectionArtifactActive(item.Accordance, recordStatusTooltip(APP_CONST.TEXT_UNPUBLISHED))}
                  >
                    {info.unpublished !== 0 ? (
                      !isOverViewLoading ? (
                        <>
                          <viedoc-icon name="block"></viedoc-icon>
                          <p>{info.unpublished}</p>
                        </>
                      ) : (
                        ""
                      )
                    ) : !isOverViewLoading && item.Accordance ? (
                      <>
                        <viedoc-icon name="block"></viedoc-icon>

                        <p>
                          {zeroArtifactHandler(
                            info.artifactId === item.artifactorigid,
                            item.Accordance,
                            info.unpublished
                          )}
                        </p>
                      </>
                    ) : (
                      " "
                    )}
                  </p>
                </Fragment>
              );
            }
          })}
      </div>
    );
  };

  const renderDocumentDateDetails = (data) => {
    return data.lastmodifiedon
      ? fullDateTimePattern
        ? UtilsHelper.getFormattedDateTime(
            fullDateTimePattern,
            data.lastmodifiedon,
            dateLocale
          )
        : UtilsHelper.momentLocalConversion(data.lastmodifiedon, true)
      : fullDateTimePattern && data.createdon
      ? UtilsHelper.getFormattedDateTime(
          fullDateTimePattern,
          data.createdon,
          dateLocale
        )
      : UtilsHelper.momentLocalConversion(data.createdon, true);
  };

  const renderDocumentCreatorDetails = (data) => {
    return (
      data.createdby && (
        <>
          {` ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
            userList,
            data.lastmodifiedby ? data.lastmodifiedby : data.createdby
          )}`}
        </>
      )
    );
  };

  const renderDateAndCreatorDetails = (data) => {
    const dateDetail = renderDocumentDateDetails(data);

    const creatorDetail = renderDocumentCreatorDetails(data);
    return dateDetail ? dateDetail + creatorDetail?.props?.children : "";
  };

  const iconList = (documentData) => {
    let icon = "";
    switch (documentData.status) {
      case "Unpublished":
        icon = "block";
        break;
      case "Scanning in progress":
        icon = "block";
        break;
      case "Finalized":
        icon = "check";
        break;
      case "Awaiting review":
        icon = "load";
        break;
      case "Flagged by QC":
        icon = "flag";
        break;
      default:
        break;
    }
    return icon;
  };

  const getStatus = (status) => {
    switch (status) {
      case APP_CONST.TEXT_FINALIZED:
        return t("TMF.TEXT_FINALIZED");
      case APP_CONST.TEXT_AWAITINGREVIEW:
        return t("TMF.TEXT_AWAITING");
      case APP_CONST.TEXT_UNPUBLISHED:
        return t("TMF.TEXT_UNPUBLISHED");
      case APP_CONST.TEXT_FLAGGEDBYQC:
        return t("TMF.TEXT_FLAGGEDBYQC");
      default:
        return status;
    }
  };

  const onDownloadIconClick = (data, isDialog) => {
    setDownloadingDocId(data.docid);
    let downTemplate = "";
    const origfilename = data?.downloadtemplate
      ? data?.downloadtemplate
      : data.origfilename.split(`.${data.type}`)[0];
    let downloadFileName = "";
    if(!(isDocNewVersionCreated && tmpfileGuid)){
    downloadFileName =  downTemplate && downTemplate !== ""
        ? downTemplate
        : data.title === "customName"
        ? data.customTitle
        : APP_CONST.TITLE_ARRAY.includes(data.title)
        ? data.documenttypevalue || data.artifact
        : origfilename;
    } else {
    downloadFileName = !_.isEmpty(tmpSingleFileDetail) ? tmpSingleFileDetail[0].name : origfilename
    }
    const fileProps = {
      ...data,
      downloadFileName,
    };
    data.tmfdropzoneid || data.category
      ? dispatch(
          fileUploadActions.fileDownloadUrl(
            UtilsHelper.prepareDownloadRequestPayload(fileProps),
            isDialog,
            data.category
          )
        )
      : dispatch(
          fileUploadActions.fileDownloadUrl(
            UtilsHelper.prepareDownloadRequestPayload(fileProps),
            isDialog,
            "",
            fileProps,
            isDocNewVersionCreated && tmpfileGuid ? tmpfileGuid : "",
            isDocNewVersionCreated && tmpfileGuid ? tmpSingleFileDetail[0].name : "",
          )
        );
    // downloadFile(fileProps);
  };

  const documentDetailsHandler = async (documentDetails) => {
    if (
      ![
        APP_CONST.TEXT_UNPUBLISHED,
        APP_CONST.TEXT_FLAGGEDBYQC,
        APP_CONST.TEXT_AWAITINGREVIEW,
        APP_CONST.TEXT_FINALIZED,
      ].includes(documentDetails.status)
    )
      return;
    if (deletingDocuments.includes(documentDetails.documentid)) return;
    const artifactUserAccess = artifactsData?.filter(
      (artdata) => artdata.artifactorigid === documentDetails.origiartifactid
    )[0]?.artifactuseraccess;
    const rolePermission = artifactsData?.filter(
      (artdata) => artdata.artifactorigid === documentDetails.origiartifactid
    )[0]?.rolePermission;
    const reqObject = {
      artifactuseraccess: artifactUserAccess,
      rolePermission: rolePermission,
      documenttmflevel: documentDetails.documenttmflevel,
      sitesid: documentDetails.sitesid,
      countriesid: documentDetails.countriesid,
      countrySiteList,
    };
    const permissionObject = UtilsHelper.permissionObject(reqObject);
    setSelectedDocId(documentDetails.docid);
    setSelectedDocArtifactId(documentDetails.origiartifactid);
    setDocDetails({
      ...documentDetails,
      ...permissionObject,
    });
    setSelectedArtifactDetails(
      artifactsData.find(
        (artifact) =>
          artifact.artifactorigid === documentDetails.origiartifactid
      )
    );

    setViewDocumentObj(true);
    const {
      documentid,
      lastmodifiedon,
      documentversionguid,
      docid,
      createdon,
      tmfdropzoneid,
      trialmasterfilesharingsettings,
    } = documentDetails;
    const lastModifiedOn = lastmodifiedon ? lastmodifiedon : createdon;
    const payloadData = { documentid, lastModifiedOn, documentversionguid };

    dispatch(
      documentActions.getDocNote(
        documentversionguid,
        tmfdropzoneid ? tmfdropzoneid : APP_CONST.HARD_CODED.dummyId
      )
    );

    !["Unpublished", "Finalized"].includes(documentDetails?.status) &&
      dispatch(
        documentActions.documentGetReview({ documentid, documentversionguid })
      );

    dispatch(
      documentActions.getDocumentContentDetails(documentid, documentversionguid)
    );

    dispatch(documentActions.getDocumentHistory(payloadData));

    !["Unpublished"].includes(documentDetails?.status) &&
      dispatch(documentActions.doGetDocumentVersionList(docid));
    dispatch(documentActions.getAdminSharingSettings());

    dispatch(documentActions.getAdminSharingSettings());
    !["Unpublished"].includes(documentDetails?.status) &&
      dispatch(documentActions.getDocSharingMetricsByVersionId(documentid));
    const reqPayload = {
      documentid: documentid,
      isForceDataGet: true,
      lastModifiedOn: null,
    };
    dispatch(documentActions.getExistingSharedUsersList(reqPayload));

    dispatch(
      documentActions.getDocSharingUserList({
        documentid,
        isrequiredclinic: true,
        isrequiredsubject:
          trialmasterfilesharingsettings?.isenabledforsubjectusers || false,
      })
    );
  };

  const onDocRemove = (documentObj) => {
    let errorList = JSON.parse(StorageHelper.getErrorDocument());
    if (!_.isEmpty(errorList)) {
      let removeErr = errorList.filter(
        (err) => err.documentguid !== documentObj.documentguid
      );
      StorageHelper.setErrorDocument(removeErr);
    }
    updateArtifactList(documentObj, "delete");
  };

  const closeEvent = (e, data, type) => {
    e.stopPropagation();
    const { documentid, uploadProgress } = data;
    type === "Close" && onDocRemove(data);
    type === "Cancel" && dispatch(zoneActions.cancelDocId(documentid));

    if (uploadProgress === undefined || data.comments !== null) {
      dispatch({ type: "CANCLE_LOCAL_DOCUMENT", payload: data });
    }
    type === "Cancel" && dispatch(documentActions.cancelUpload(documentid));
    updatedArray(documentDataList[data.origiartifactid]);
    setDocDetails({});
  };

  const renderLevelList = (list) => {
    const listlength = list.length;
    const arrayList = list.map((obj) => `${obj} ${t("ADMIN.TEXT_LEVEL")}`);
    let returnTxt = "";
    switch (listlength) {
      case 1:
        returnTxt = ` ${arrayList[0]} `;
        break;
      case 2:
        returnTxt = ` ${arrayList[0]} & ${arrayList[1]} `;
        break;
      default:
        returnTxt = [
          arrayList.slice(0, -1).join(", "),
          arrayList.slice(-1)[0],
        ].join(arrayList.length < 2 ? "" : " & ");
        break;
    }
    return ` ${returnTxt} `;
  };

  const getDocumentLocation = (data) => {
    const listToString = (inputData, propList) => {
      let returnList = inputData.map((obj, i) => {
        const findObj = _.find(propList, { id: obj });
        return `${!_.isEmpty(findObj) ? `${findObj.description}` : ""}`;
      });
      returnList = returnList.filter((list) => !_.isEmpty(list) && list);
      returnList = returnList.join(", ");
      return returnList;
    };
    switch (data.documenttmflevel) {
      case "Trial":
        return (
          <div className="dataText" title={data.documenttmflevel}>
            {data.documenttmflevel}
          </div>
        );
      case "Site":
        const siteDiv = listToString(data.sitesid, countrySiteList.site);
        return (
          <div className="dataText" title={siteDiv}>
            {siteDiv}
          </div>
        );
      case "Country":
        const countryDiv = listToString(
          data.countriesid,
          countrySiteList.country
        );
        return (
          <div className="dataText" title={countryDiv}>
            {countryDiv}
          </div>
        );
      default:
        return "";
    }
  };

  const documentFilterList = (item) => {
    let filterDocument = [];
    let milestoneArr = checkSelectedMilestone(latestMileFilter);
    if (
      latestMileFilter === "ALL" &&
      latestCountryFilter === "ALL" &&
      latestSiteFilter === "ALL"
    ) {
      return docList[item];
    } else {
      filterDocument = docList[item]?.filter((filterDoc) => {
        if (latestCountryFilter === "Trial") {
          if (latestMileFilter !== "ALL") {
            if (
              _.isEmpty(filterDoc.countriesid) &&
              _.isEmpty(filterDoc.sitesid) &&
              filterDoc.documenttmflevel !== ""
            ) {
              return loadSelectedMilestoneData(filterDoc, milestoneArr);
            }
          } else {
            return filterDoc.documenttmflevel === latestCountryFilter;
          }
        }

        if (latestCountryFilter === "ALL" && latestSiteFilter === "ALL") {
          if (latestMileFilter !== "ALL") {
            return loadSelectedMilestoneData(filterDoc, milestoneArr);
          } else {
            return filterDoc;
          }
        }

        if (
          latestCountryFilter !== "ALL" &&
          latestSiteFilter === "ALL" &&
          latestCountryFilter !== "Trial"
        ) {
          if (latestMileFilter !== "ALL") {
            return (
              filterDoc.countriesid.includes(latestCountryFilter) &&
              filterDoc &&
              loadSelectedMilestoneData(filterDoc, milestoneArr)
            );
          } else {
            return (
              filterDoc.countriesid.includes(latestCountryFilter) && filterDoc
            );
          }
        }

        if (latestCountryFilter !== "ALL" && latestSiteFilter !== "ALL") {
          if (latestMileFilter !== "ALL") {
            return (
              (latestCountryFilter === "Trial"
                ? filterDoc.documenttmflevel === "Trial"
                : filterDoc.countriesid.includes(latestCountryFilter)) &&
              filterDoc.sitesid.includes(latestSiteFilter) &&
              filterDoc &&
              loadSelectedMilestoneData(filterDoc, milestoneArr)
            );
          } else {
            return (
              (latestCountryFilter === "Trial"
                ? filterDoc.documenttmflevel === "Trial"
                : filterDoc.countriesid.includes(latestCountryFilter)) &&
              filterDoc.sitesid.includes(latestSiteFilter) &&
              filterDoc
            );
          }
        }
      });
      return filterDocument;
    }
  };

  const renderArtifactDocuments = (item, fullList) => {
    if (_.isEmpty(metricsData) || _.isEmpty(metricsData?.artifactinfo)) return;
    const documentRequired = metricsData?.artifactinfo?.filter(
      (i) => i.artifactid === item
    );
    return (
      <>
        {fullList.Accordance && (
          <>
            <>
              {documentRequired[0]?.docrequiredlevels?.length > 0 ? (
                <div className="error-artifacts">
                  <p className="close-document">
                    <viedoc-icon name="required" />
                  </p>
                  <p className="error-artifacts-text">
                    {`${t("TMF.TEXT_ARTIFACTMANDATORY")} ${t(
                      "TMF.TEXT_ON"
                    ).toLowerCase()}`}
                    {renderLevelList(documentRequired[0]?.docrequiredlevels)}
                  </p>
                </div>
              ) : null}
            </>
            {(_.isEmpty(docList[item]) && artifactLoading) || sectionLoading ? (
              <div className="d-flex align-center jc-center h-3 bb-2">
                <viedoc-spinner />
              </div>
            ) : !_.isEmpty(docList[item]) ? (
              documentFilterList(item).map((data, index) => (
                <Fragment key={data.docid}>
                  <div
                    className={
                      "artifact-detail-view " +
                      (data.comments
                        ? "artifact-error-bg"
                        : "artifact-non-error")
                    }
                    onClick={() =>
                      !data?.docid && artifactLoading && index === 0
                        ? null
                        : documentDetailsHandler(data)
                    }
                  >
                    <div className="artifact-document">
                      {data.comments ? (
                        <p>
                          <viedoc-icon
                            title={data.comments}
                            name="close"
                          ></viedoc-icon>
                        </p>
                      ) : data.status === "Scanning in progress" ||
                        (artifactLoading && index === 0 && data.comments) ? (
                        <viedoc-spinner
                          size="small"
                          class="spinner"
                        ></viedoc-spinner>
                      ) : (
                        <viedoc-icon
                          title={getStatus(data.status)}
                          name={iconList(data)}
                        ></viedoc-icon>
                      )}
                    </div>
                    <div
                      title={data.displaytemplate || data.origfilename}
                      className="artifact-name"
                    >
                      {data.displaytemplate || data.origfilename}
                    </div>
                    {!data.comments && (
                      <>
                        <div className="artifact-type">
                          {UtilsHelper.getFileExtension(
                            data.documentname
                          ).toUpperCase()}
                        </div>
                        <div
                          className="artifact-uploaded"
                          title={renderDateAndCreatorDetails(data)}
                        >
                          <div className="sync">
                            <viedoc-icon name="sync"></viedoc-icon>
                          </div>
                          <p>{renderDateAndCreatorDetails(data)}</p>
                        </div>
                      </>
                    )}
                    {data.comments ? (
                      <div className="unsupported-text" title={data.comments}>
                        {t("TMF.TEXT_FILEUPLOADFAILED")}
                      </div>
                    ) : (
                      <div className="artifact-state">
                        {getDocumentLocation(data)}
                      </div>
                    )}

                    <div className="artifact-action">
                      {data.islocked && (
                        <viedoc-icon
                          title={t("ADMIN.TEXT_LOCKED")}
                          name="lock"
                        ></viedoc-icon>
                      )}
                    </div>

                    {data.status === "Scanning in progress" && (
                      <div className="artifact-progress">
                        <ProgressBar progress={data.uploadProgress || 7} />
                        {data.uploadProgress !== 99 && (
                          <viedoc-icon
                            name="delete"
                            title={t("TMF.BUTTON_CANCELBTN")}
                            onClick={(e) => closeEvent(e, data, "Cancel")}
                          >
                            {" "}
                          </viedoc-icon>
                        )}
                      </div>
                    )}
                    {data.status !== "Unpublished" &&
                      deletingDocuments.includes(data.documentid) && (
                        <div className="artifact-download  mr-12">
                          <viedoc-spinner class="download__spinner"></viedoc-spinner>
                        </div>
                      )}
                    {data.status === "Unpublished" &&
                      !isEtmfLocked &&
                      data?.writePermission && (
                        <div
                          className="artifact-download  mr-12"
                          title={t("TMF.TEXT_DELETE")}
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowDocDeletePopup(true);
                            setSectionOrigid(data.sectionid);
                            setorigiartifactid(data.origiartifactid);
                            setDocDeleteData({
                              ...docDeleteData,
                              id: data.documentid,
                              lastModifiedOn:
                                data.lastmodifiedon || data.createdon,
                              fileName: data.origfilename,
                            });
                            setDocList(documentDataList);
                          }}
                        >
                          {deletingDocuments.includes(data.documentid) ? (
                            <viedoc-spinner class="download__spinner"></viedoc-spinner>
                          ) : (
                            <viedoc-icon name="delete_bin"></viedoc-icon>
                          )}
                        </div>
                      )}

                    {data.status !== "Scanning in progress" &&
                      data.artifact !== null && (
                        <div
                          className="artifact-download"
                          title={t("TMF.TEXT_DOWNLOAD")}
                          onClick={(e) => {
                            e.stopPropagation();
                            onDownloadIconClick(data, false);
                          }}
                        >
                          {!data.comments ? (
                            <>
                              {downLoader && data.docid === downloadingDocId ? (
                                <viedoc-spinner class="download__spinner"></viedoc-spinner>
                              ) : (
                                <viedoc-icon name="download"></viedoc-icon>
                              )}
                            </>
                          ) : (
                            <div className="artifact-progress">
                              <viedoc-icon
                                name="delete"
                                title={t("TMF.BUTTON_CLOSEBTN")}
                                onClick={(e) => closeEvent(e, data, "Close")}
                              >
                                {" "}
                              </viedoc-icon>
                            </div>
                          )}
                        </div>
                      )}
                  </div>
                </Fragment>
              ))
            ) : (
              renderNoDocumentMsg()
            )}
          </>
        )}
      </>
    );
  };

  const uploadDocumentData = (uploadFile, guid = null, properties, dropArtifactId) => {
    const documentItem = UtilsHelper.constructDocumentUploadObject(
      uploadFile,
      guid,
      properties
    );

    const reqObject = {
      artifactuseraccess: artifactUserAccess,
      rolePermission: rolePermission,
      documenttmflevel: documentItem.documenttmflevel,
      sitesid: documentItem.sitesid,
      countriesid: documentItem.countriesid,
      countrySiteList,
    };
    const permissionObject = UtilsHelper.permissionObject(reqObject);

    let ZoneDetails = zoneData.find((item) => item.id === zoneId);
    documentItem.zone = ZoneDetails.name;
    documentItem.section = ZoneDetails.sections.find(
      (item) => item.id === sectionId
    ).name;

    const zoneIndex = zoneData.find((item) => item.id === zoneId);

    const sectionIndex = zoneIndex?.sections?.find(
      (item) => item.id === sectionId
    );

    const uploadArtifactId = dropArtifactId ? dropArtifactId : artifactId

    let artifcatList = sectionIndex?.artifacts;
    const artifactDetail = artifcatList?.find(
      (item) => item.origid === uploadArtifactId
    )
    const fileformats = artifactDetail?.fileformats;
    documentItem.artifact = artifactDetail?.name;
    documentItem.datingconventionlabel = properties.datingConvention;

    const fileType = UtilsHelper.getFileExtension(uploadFile.name);
    const allowAllFormats = fileformats.length === 1 && fileformats[0] === "*";

    if (
      (allowAllFormats &&
        !APP_CONST.BLACK_LISTED_FILE_FORMATS.includes(fileType) &&
        uploadFile.size !== 0) ||
      (fileformats.includes(fileType) &&
        uploadFile.size !== 0 &&
        !APP_CONST.BLACK_LISTED_FILE_FORMATS.includes(fileType))
    ) {
      const documentData = {
        ...documentItem,
        ...permissionObject,
        isUploading: true,
        uploadingProgress: UtilsHelper.randomNumber([7, 13, 10, 17]),
      };
      onDocInsert(documentData);
      let passData = {};
      passData.artifactId = parseInt(properties.origid.split(".")[2]);
      passData.origiartifactid = properties.origid;
      let docDet = {};
      docDet.documentDetails = documentItem;

      passData.documentContents = JSON.stringify(docDet);

      let filePassPayload = {};
      filePassPayload.docItem = passData;
      filePassPayload.files = uploadFile;
      dispatch(
        fileUploadActions.fileUpload({
          filePassPayload,
          guid,
          viewPerPageCount,
        })
      );
    } else {
      const documentData = { ...documentItem, isUploading: false };
      if (
        APP_CONST.BLACK_LISTED_FILE_FORMATS.includes(fileType) &&
        uploadFile.size !== 0
      ) {
        documentData.comments = `${t("TMF.TOAST_INVALIDBLOCKLISTFILE")}`;
      } else if (uploadFile.size === 0) {
        documentData.comments = `${t("TMF.TOAST_FILEEMPTY")}`;
      } else {
        documentData.comments = `${t(
          "TMF.TOAST_INVALIDFILEFORMATS"
        )} ${fileformats}.`;
      }
      onDocInsert(documentData);
    }
  };

  const onDocInsert = (documentDetails) => {
    if (documentDetails.isUploading) {
      const documentObj = {
        ...documentDetails,
        status: "Scanning in progress",
      };
      updateArtifactList(documentObj, "add");
    } else {
      const documentObj = {
        ...documentDetails,
        status: "Error",
      };
      let existErrorData = JSON.parse(StorageHelper.getErrorDocument());
      existErrorData.push(documentObj);
      StorageHelper.setErrorDocument(existErrorData);
      updateArtifactList(documentObj, "add");
    }
  };

  const updateArtifactList = (data, crud) => {
    const localStore = storageFactory(() => sessionStorage);
    data.createdby = JSON.parse(localStore.getItem("studyconfig")).userid;
    // data.lastmodifiedon = moment.utc().format("YYYY-MM-DDTHH:mm:ss");
    // data.status = "Unpublished";
    if (!documentDataList[data.origiartifactid]) {
      let groupDocument = _.isEmpty(data)
        ? []
        : _.groupBy([data], "origiartifactid");
      dispatch({ type: "RESET_DOCUMENT_DATA_LIST", payload: groupDocument });
    } else {
      if (crud === "add" || crud === "delete") {
        documentDataList[data.origiartifactid].unshift(data);
      } else if (crud === "update") {
        let returnDocumentList = documentDataList[data.origiartifactid] || [];
        const findIndex = _.findIndex(documentDataList[data.origiartifactid], {
          documentguid: data.documentguid || data.documentid,
        });
        const findObj = _.find(documentDataList[data.origiartifactid], {
          documentguid: data.documentguid || data.documentid,
        });
        if (findIndex !== -1)
          returnDocumentList[findIndex] = { ...findObj, ...data };
        else returnDocumentList.unshift(data);
        const documentList = UtilsHelper.removeDuplicates(
          returnDocumentList,
          "documentguid"
        );
        documentDataList[data.origiartifactid] = [...documentList];
      }
      dispatch({ type: "RESET_DOCUMENT_DATA_LIST", payload: documentDataList });
    }
  };

  const documentUploadHandler = (files, arId, dropArtifactId) => {
    if (isEtmfLocked) return;

    const zoneIndex = zoneData.find((item) => item.id === zoneId);

    const sectionIndex = zoneIndex?.sections?.find(
      (item) => item.id === sectionId
    );

    let artifactList = sectionIndex?.artifacts;
    
    const uploadArtifactId = dropArtifactId ? dropArtifactId : arId;

    let currentSelection = artifactList.find((item) => item.origid === uploadArtifactId);
    let origid = currentSelection?.origid;
    let name = currentSelection?.name;
    let datingConvention = currentSelection?.datingconvention;

    const properties = { origid, name, datingConvention };
    const fileData = Array.from(files);
    for (let i = 0; i < fileData.length; i++) {
      setTimeout(() => {
        DocumentService.doGetDocumentGuid()
          .then((response) => {
            const { isError, result } = response.data;
            if (!isError) {
              uploadDocumentData(fileData[i], result.documentguid, properties, dropArtifactId);
            }
          })
          .catch(() => {
            dispatch(
              actionsLoader.showError(
                t("TMF.TOAST_SOMETHINGWENTWRONG"),
                "error",
                "warning"
              )
            );
          });
      }, 200 * i);
    }
  };

  const renderTrialTableHeader = () => {
    const artifactList =
      latestMileFilter !== "ALL"
        ? artifactsData?.filter(
            (filterData) =>
              latestMileFilter === "ALL" ||
              filterData.milestonesId.includes(latestMileFilter) ||
              filterData.milestonesgroup.includes(latestMileFilter)
          ) ?? []
        : artifactsData;
    return (
      <>
        {!_.isEmpty(artifactList) ? (
          artifactList.map((item, index) => (
            <div
              key={index}
              {...getRootProps({"data-custom-artifactId" : item.artifactorigid})}
              style={{
                border:
                  !isEtmfLocked &&
                  dragContainer &&
                  item.artifactorigid === artifactId &&
                  "2px dashed grey",
              }}
              onDragEnter={() => setDragContainer(true)}
              onDragLeave={() => setDragContainer(false)}
            >
              <div
                className={`d-flex align-center section-bg bb-1 ${
                  item.Accordance ? "isActive-artifact" : ""
                }`}
                onClick={(e) => {
                  if (e.target.id !== "doc-upload") {
                    getArtifactsHandler(item, false, "preventDispatchEvent");
                  }
                }}
              >
                <div className="zone-section-detail-view" title={item.artifactorigid + " " + item.artifacts}>
                  <viedoc-icon
                    name={item.Accordance ? "artifacts" : "folder"}
                    class={item.Accordance ? "zones-grey" : "zones-dark"}
                  />
                  <p
                    className={item.isdeleted ? "deleted-zdata" : ""}
                    title={item.artifactorigid + " " + item.artifacts}
                  >
                    {settings.showstructurenumber
                      ? `${item.artifactorigid} ${item.artifacts}`
                      : item.artifacts}
                  </p>
                </div>
                {renderTrialSubsections(item)}
                <div className="zone-download">
                  <p title={t("TMF.TEXT_UPLOAD")}>
                    {!isEtmfLocked &&
                      checkRolePermission(item) &&
                      !item.isdeleted && (
                        <>
                          <viedoc-icon
                            id="doc-upload"
                            name="upload"
                            class="upload"
                            onClick={(e) => {
                              getArtifactsHandler(item, true, e.target.id);
                              !_.isEmpty(fileRef.current) &&
                                fileRef.current.click();
                            }}
                          />
                          <input
                            {...getInputProps()}
                            id="doc-upload"
                            className="d-sm-none"
                            ref={(el) => {
                              fileRef.current = el;
                              setFileRefVisible(!!el);
                            }}
                            type="file"
                            multiple
                            onChange={(e) =>
                              documentUploadHandler(e.target.files, artifactId)
                            }
                            onClick={(event) => {
                              event.target.value = null;
                            }}
                          />
                        </>
                      )}
                  </p>
                </div>
              </div>

              {renderArtifactDocuments(item.artifactorigid, item)}
              <div className="artifact-list bb-1">
                <p className="">{item?.artifactMandatory?.artifactMSG}</p>
              </div>
            </div>
          ))
        ) : (
          <>
            {!_.isEmpty(artifactsData) && (
              <div className={`d-flex align-center section-no-artifact f14`}>
                <div className="section-no-detail-view">
                  <viedoc-icon name={"artifacts"} class={"zones-dark"} />
                </div>
                {t("TMF.TEXT_NOARTIFACTFOUND")}
              </div>
            )}
          </>
        )}
      </>
    );
  };

  const renderNoDocumentMsg = () => {
    return (
      <div className="dragndrop light-grey bb-1">
        <p className="pl-20">{t("TMF.TEXT_DRAGANDDROPINFO")} </p>
      </div>
    );
  };

  return (
    <>
      {lockStatus !== APP_CONST.ADMIN_TEMPLATE_STATUS[1] ? (
        <PlaceholderComponent title={t("TMF.TEXT_STUDYNOTINSTANTIATED")} />
      ) : (
        <div className="zone-section_structure">
          {renderHeaderComponent()}
          <section className="d-flex">
            <aside className="zone-sidepanel">
              <section>
                {renderZoneSectionHeader()}
                {documentsLoading ? (
                  <Loader width={"25%"} height={"100%"} />
                ) : (
                  renderZoneSectionTable()
                )}
              </section>
            </aside>
            <article className="zone-details">
              <section className="bl-1">
                {viewDocumentObj && (
                  <DocumentViewModal
                    onDownloadIconClick={onDownloadIconClick}
                    docDetails={docDetails}
                    setViewDocumentObj={setViewDocumentObj}
                    setDocFilterUsed={setDocFilterUsed}
                    selectedArtifactDetails={selectedArtifactDetails}
                    documentPermission={
                      selectedArtifactDetails &&
                      selectedArtifactDetails.origid !== "00.00.00"
                        ? selectedArtifactDetails.rolePermission || ""
                        : "WRITE"
                    }
                    downloadingDocId={downloadingDocId}
                    setDownloadingDocId={setDownloadingDocId}
                    setTmpFileGuid={setTmpFileGuid}
                    setTmpSingleFileDetail={setTmpSingleFileDetail}
                    setIsDocNewVersionCreated={setIsDocNewVersionCreated}
                  />
                )}
                {showDocDeletePopup && (
                  <DeleteDocumentPopUp
                    deletePayload={docDeleteData}
                    setShowDocDeletePopup={setShowDocDeletePopup}
                    sectionOrigid={sectionOrigid}
                    origiartifactid={getorigiartifactid}
                  />
                )}
                {renderTrialTableHeader()}
              </section>
            </article>
          </section>
        </div>
      )}
    </>
  );
};

export default ZonesSections;
